import { SubProjectImmoText } from 'src/app/model/project/sub-project-immo-text';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import * as moment from 'moment';

export class TextImmoOverviewHelper {
  private constructor() {}

  static sortByTourDate(items: SubProjectImmoText[]): void {
    if (!CollectionHelper.isPopulated(items)) {
      return;
    }
    items.sort(TextImmoOverviewHelper.compare);
  }

  private static compare(
    i1: SubProjectImmoText,
    i2: SubProjectImmoText
  ): number {
    const i1HasTourDate = TextImmoOverviewHelper.hasTourDate(i1);
    const i2HasTourDate = TextImmoOverviewHelper.hasTourDate(i2);

    if (!i1HasTourDate && !i2HasTourDate) {
      return 0;
    }
    if (i1HasTourDate && !i2HasTourDate) {
      return -1;
    }
    if (!i1HasTourDate && i2HasTourDate) {
      return 1;
    }

    return moment(i1.tourItem.tour.date).diff(moment(i2.tourItem.tour.date));
  }

  private static hasTourDate(i: SubProjectImmoText): boolean {
    return (
      i.tourItem != null &&
      i.tourItem.tour != null &&
      i.tourItem.tour.date != null
    );
  }
}
